import { LINK, PATH } from '@/constants';
import BundleBuilder from '@/components/BundleBuilder';
import Dashboard from '@/pages/Dashboard';
import Feedback from '@/pages/Feedback';
import Notifications from '@/pages/Notifications';
import EmailRecipient from '@/pages/Notifications/Email/components/EmailRecipient';
import EmailSender from '@/pages/Notifications/Email/components/EmailSender';
import EmailTemplatesDetail from '@/pages/Notifications/Email/components/EmailTemplatesDetail';
import SubscriptionPlans from '@/pages/Plan';
import Settings from '@/pages/Settings';
import ShipmentAnalytics from '@/pages/ShipmentAnalytics';
import Shipments from '@/pages/Shipments';
import ShipmentDetail from '@/pages/Shipments/components/ShipmentDetail';
import TrackingLogs from '@/pages/Shipments/components/TrackingLogs';
import TrackingPage from '@/pages/TrackingPage';
import Blacklisting from '@/pages/TrackingPage/components/Blacklisting';
import EstimatedDeliveryDate from '@/pages/TrackingPage/components/EDD';
import TrackingConfigurationPage from '@/pages/TrackingPage/components/EDD/components/ModalTrackingPage';
import TransitTimeEditor from '@/pages/TrackingPage/components/EDD/components/TransitTimeEditor';
import TransitTimeEditorDetail from '@/pages/TrackingPage/components/EDD/components/TransitTimeEditorDetail';
import LanguagesPage from '@/pages/Languages';
import LanguageEditorPage from '@/pages/Languages/editor';
import Welcome from '@/pages/Welcome';
import store, { RootState } from '@/redux/store';
import { IRouter } from '@/types/route';
import { useNavigate } from 'react-router-dom';
import {
  ChartVerticalFilledIcon,
  DeliveryIcon,
  DomainLandingPageIcon,
  EmailIcon,
  HomeIcon,
  NotificationIcon,
  PersonIcon,
  SettingsIcon,
  ViewIcon,
} from '@shopify/polaris-icons';

const BundleBuilderPage = () => {
  const navigate = useNavigate();
  return <BundleBuilder onBack={() => navigate(PATH.PLAN)} />;
};

const getRouteList = (proxyPath?: string): Array<IRouter> => {
  const {
    auth: {
      data: { shop },
    },
  } = store.getState() as RootState;

  return [
    {
      name: 'Dashboard',
      path: PATH.DASHBOARD,
      element: <Dashboard />,
      icon: HomeIcon,
    },
    {
      name: 'Analytics',
      icon: ChartVerticalFilledIcon,
      path: PATH.ANALYTICS,
      element: <ShipmentAnalytics />,
    },
    {
      name: 'Shipments',
      path: PATH.SHIPMENT,
      element: <Shipments />,
      icon: DeliveryIcon,
    },
    {
      name: 'Tracking Page',
      path: PATH.TRACKING_PAGE,
      element: <TrackingPage />,
      icon: DomainLandingPageIcon,
      actionIcon: {
        accessibilityLabel: 'View',
        url: LINK.CUSTOMER_SHOP(shop, proxyPath),
        icon: ViewIcon,
      },
    },
    {
      name: 'Tracking Configuration Page',
      path: PATH.TRACKING_CONFIGURATION_PAGE,
      element: <TrackingConfigurationPage />,
      hiddenInSidebar: true,
    },
    {
      path: PATH.TRANSIT_TIME,
      element: <TransitTimeEditor />,
      hiddenInSidebar: true,
    },
    {
      path: PATH.TRANSIT_TIME_DETAIL,
      element: <TransitTimeEditorDetail />,
      hiddenInSidebar: true,
    },
    {
      path: PATH.LANGUAGES,
      element: <LanguagesPage />,
      hiddenInSidebar: true,
    },
    {
      path: PATH.LANGUAGE_EDITOR,
      element: <LanguageEditorPage />,
      hiddenInSidebar: true,
    },
    {
      name: 'Settings',
      path: PATH.SETTINGS,
      element: <Settings />,
      icon: SettingsIcon,
    },
    {
      name: 'Notifications & Alerts',
      icon: NotificationIcon,
      path: PATH.NOTIFICATIONS,
      element: <Notifications />,
    },
    {
      path: PATH.EMAIL_TEMPLATE,
      element: <EmailTemplatesDetail />,
      hiddenInSidebar: true,
    },
    {
      path: PATH.SENDER_EMAIL,
      element: <EmailSender />,
      hiddenInSidebar: true,
    },
    {
      path: PATH.RECIPIENT_EMAIL,
      element: <EmailRecipient />,
      hiddenInSidebar: true,
    },
    {
      name: 'Feedback',
      path: PATH.FEEDBACK,
      element: <Feedback />,
      icon: EmailIcon,
    },
    {
      name: 'Subscription Plans',
      path: PATH.PLAN,
      element: <SubscriptionPlans />,
      icon: PersonIcon,
    },
    {
      path: PATH.PLAN_BUNDLE,
      element: <BundleBuilderPage />,
      hiddenInSidebar: true,
    },
    {
      path: PATH.SHIPMENT_DETAIL,
      element: <ShipmentDetail />,
      hiddenInSidebar: true,
    },
    {
      path: PATH.TRACKING_LOGS,
      element: <TrackingLogs />,
      hiddenInSidebar: true,
    },
    {
      path: PATH.POST_PURCHASE_EDD,
      element: <EstimatedDeliveryDate />,
      hiddenInSidebar: true,
    },
    {
      path: PATH.PRE_PURCHASE_EDD,
      element: <EstimatedDeliveryDate />,
      hiddenInSidebar: true,
    },
    {
      path: PATH.BLACKLIST,
      element: <Blacklisting />,
      hiddenInSidebar: true,
    },
    {
      path: PATH.WELCOME,
      element: <Welcome />,
      hiddenInSidebar: true,
    },
  ];
};

export default getRouteList;
